import { useState, useRef, Fragment, useEffect } from 'react';
import {
    Button,
    ClickAwayListener,
    DialogActions,
    Dialog,
    DialogTitle,
    DialogContent,
    FormControl,
    Grow,
    Hidden,
    IconButton,
    MenuItem,
    MenuList,
    Paper,
    Popper,
    Tooltip,
    TextField,
    Typography,
} from '@material-ui/core';
import HelpIcon from '@material-ui/icons/Help';
import { makeStyles } from '@material-ui/core/styles';
import { Auth } from 'aws-amplify';
import { host, enableBilling } from "../../../data";
import pulseHubInfoImg from './Assets/PulseHubUid.png';
import cellularInfoImg from './Assets/Cellular_UID_ti40038.png';
import pressureInfoImg from './Assets/Pressure_UID_ti40037.png';
import WiFiInfoImg from './Assets/WiFi_UID_ti40039.png';
import WiFiActivationCodeImg from './Assets/WiFi_ActivationCode_ti40040.png';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    indented: {
        marginLeft: theme.spacing(10),
    },
    content: {
        padding: theme.spacing(2),
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120
    },
    actionButtons: {
        marginTop: theme.spacing(2),
    },
    helpButton: {
        marginTop: theme.spacing(2),
    },
    formControlLabel: {
        marginLeft: theme.spacing(2),
    },
    rootpaper: {
        width: 1000,
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
        overflowX: "auto"
    },
    HubInfoImg: {
        maxHeight: '200px',
        marginRight: theme.spacing(2),
    },
    infoDialog: {
        maxWidth: 'sm',
        fullWidth: 'true'
    },
    table: {
        width: 1200,
        height: '55vh',
    },
    link: {
        color: theme.palette.info.dark,
    },
    buttonProgress: {
        position: 'absolute',
        marginRight: 36,
    },
}));

const ActivateDevice2 = ({ orgInfo, setDevices, billingData, setBillingData, orgBilling }) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const [deviceUID, setDeviceUID] = useState();
    const rdeviceUID = useRef();
    const [deviceUID2, setDeviceUID2] = useState();
    const rdeviceUID2 = useRef();
    const [activationCode, setActivationCode] = useState("");
    const ractivationCode = useRef("");
    const [addDeviceDialogue, setOpenDeviceDialogue] = useState(false);
    const [hasBillingInfo, setHasBillingInfo] = useState(!enableBilling);
    const [deviceFamily, setDeviceFamily] = useState();
    const [targetUID, setTargetUID] = useState();
    const [openCellularInfo, setOpenCellularInfo] = useState(false);
    const [openPressureInfo, setOpenPressureInfo] = useState(false);
    const [openWiFiInfo, setOpenWiFiInfo] = useState(false);
    const [openHubInfo, setOpenHubInfo] = useState(false);
    const [helpOpen, setHelpOpen] = useState(false);
    const [helpAnchor, setHelpAnchor] = useState();
    const [openEnterSerial, setOpenEnterSerial] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleHelpOpen = (event) => {
        setHelpAnchor(event.currentTarget);
        setHelpOpen(true);
    };

    const handleHelpClose = () => {
        setHelpOpen(false);
    };

    const handleOpenCellularInfo = () => {
        setOpenCellularInfo(true);
    };

    const handleCloseCellularInfo = () => {
        setOpenCellularInfo(false);
    };

    const handleOpenPressureInfo = () => {
        setOpenPressureInfo(true);
    };

    const handleClosePressureInfo = () => {
        setOpenPressureInfo(false);
    };

    const handleOpenWiFiInfo = () => {
        setOpenWiFiInfo(true);
    };

    const handleCloseWiFiInfo = () => {
        setOpenWiFiInfo(false);
    };

    const handleOpenHubInfo = () => {
        setOpenHubInfo(true);
    };

    const handleCloseHubInfo = () => {
        setOpenHubInfo(false);
    };

    const handleCloseEnterSerial = () => {
        setOpenEnterSerial(false);
        setDeviceUID2();
    };

    const handleOpenAddDevice = () => {
        if (deviceUID) {
            var tDeviceUID = deviceUID.replace(/\b0+/g, "");
        } else if (deviceUID2) {
            var tDeviceUID = deviceUID2.replace(/\b0+/g, "");
        } else {
            var tDeviceUID = "";
        }

        if (tDeviceUID !== "") {
            handleCloseEnterSerial();
            Auth.currentAuthenticatedUser()
                .then(data => {
                    var body = JSON.stringify({ 'UID': tDeviceUID });
                    var requestOptions = {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': data.signInUserSession.idToken.jwtToken
                        },
                        body: body,
                    };

                    fetch(host + '/device', requestOptions)
                        .then(results => results.json())
                        .then(data => {
                            if (data.error === "OK") {
                                //console.log(data);
                                if (data.isAvailable === 1) {
                                    setDeviceFamily(data.family);
                                    setOpenDeviceDialogue(true);
                                    if (data.family === "WiFi") {
                                        setTargetUID(Number(data.UID).toString());
                                    } else {
                                        setTargetUID(data.UID.toUpperCase());
                                    }
                                }
                                else {
                                    alert(t("deviceIsAlreadyAssigned"));
                                }
                            }
                            else {
                                
                                alert(data.error);
                            }
                        }).catch((error) => {
                            console.log(error)
                        })
                });
        }
        else {
            setOpenEnterSerial(true);
        }
    };
    const handleCloseAddDevice = () => {
        setOpenDeviceDialogue(false);
    };
    const handleAddDevice = () => {
        var code = activationCode;
        if (deviceFamily === "PulseHUB") {
            code = "";
        }

        if (deviceFamily === "cellular" || deviceFamily === 'pressure') {
            code = "";
        }
        var l_hasBillingInfo = hasBillingInfo ? 1 : 0;
        setOpenDeviceDialogue(false);
        Auth.currentAuthenticatedUser()
            .then(data => {
                var body = JSON.stringify({
                    'devices': [{ 'uid': targetUID, 'code': code, 'action': "add" }],
                    'hasBillingInfo': l_hasBillingInfo, 'sync': 0
                });
                var requestOptions = {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': data.signInUserSession.idToken.jwtToken
                    },
                    body: body
                };
                var url = host + '/orgs/' + orgInfo.orgId + '/ftdevices/';
                if (enableBilling) {
                    url = host + '/orgs/' + orgInfo.orgId + '/devices/';
                }

                fetch(url, requestOptions)
                    .then(results => results.json())
                    .then(data => {
                        if (data.error === "OK") {
                            setDevices(data.deviceList);
                            setDeviceUID("");
                        }
                        else {
                            if (data.error === "error" && data.errorList.length > 0) {
                                alert(data.errorList[0].error);
                            }
                            else {
                                alert(t("tryAgainOrContactTa").replace("{error}", data.error));
                                //alert(data.error)
                            }
                        }
                    }).catch((error) => {
                        console.log(error)
                    })
            });
    };

    useEffect(() => {
        if (!addDeviceDialogue) {
            setIsLoading(false);
        }
    }, [addDeviceDialogue]);

    useEffect(() => {
        //var testMsg = "some error multi mode thingy";
        //alert(t("tryAgainOrContactTa").replace("{error}",testMsg));
        if (billingData.billing_info) {
            if (billingData.billing_info.id !== undefined) {
                setHasBillingInfo(true);
            }
            else {
                setHasBillingInfo(!enableBilling);
            }
        }
    }, [billingData]);


    return (
        <Fragment>
            {openEnterSerial && <Dialog disableBackdropClick disableEscapeKeyDown open={openEnterSerial} onClose={handleCloseEnterSerial}>
                <DialogTitle>{t("enterSerialNumber")}</DialogTitle>
                <DialogContent className={classes.root}>
                    <FormControl className={classes.formControl}>
                        <TextField type="test" label={t("serialNumber")}
                            inputRef={rdeviceUID2}
                            value={deviceUID2}
                            onChange={(e) => {
                                const regex = /^([ a-zA-Z0-9]){0,30}$/i;
                                if (regex.test(e.target.value)) {
                                    setDeviceUID2(e.target.value.toUpperCase());
                                }
                            }
                            }
                            helperText={t("tankLevelMonitor")} />
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseEnterSerial} color="primary">
                        {t("cancel")}
                    </Button>
                    <Button variant="contained" onClick={handleOpenAddDevice} color="primary" disabled={!deviceUID2}>
                        {t("add")}
                    </Button>
                </DialogActions>
            </Dialog>}
            {(deviceFamily === "pressure" || deviceFamily === "cellular") && addDeviceDialogue && <Dialog disableBackdropClick disableEscapeKeyDown open={addDeviceDialogue} onClose={handleCloseAddDevice}>
                <DialogTitle>{t("addDevice")}</DialogTitle>
                <DialogContent className={classes.root}>
                    {(!enableBilling || hasBillingInfo) && <Typography variant="body2" gutterBottom>
                        {t("add")} {deviceFamily === 'PulseHUB' ? t("existingPulseProTank") : deviceFamily + " " + t("device") + " "} {targetUID}?
                    </Typography>}
                    {(enableBilling && !hasBillingInfo) && <Typography variant="body2" colorError gutterBottom>
                        {t("priorToAddingThisDevice")}
                    </Typography>}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseAddDevice} color="primary">
                        {t("cancel")}
                    </Button>
                    <Button disabled={!hasBillingInfo && enableBilling || isLoading} variant="contained" onClick={handleAddDevice} color="primary">
                        {t("confirm")}
                    </Button>
                    {isLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
                </DialogActions>
            </Dialog>}
            {deviceFamily === "PulseHUB" && addDeviceDialogue && <Dialog disableBackdropClick disableEscapeKeyDown open={addDeviceDialogue} onClose={handleCloseAddDevice}>
                <DialogTitle>{t("addDevice")}</DialogTitle>
                <DialogContent className={classes.root}>
                    <Typography variant="body2">
                        {t("addPulseProTlm")}{" " + targetUID}?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseAddDevice} color="primary">
                        {t("cancel")}
                    </Button>
                    <Button variant="contained" onClick={handleAddDevice} color="primary">
                        {t("add")}
                    </Button>
                </DialogActions>
            </Dialog>}
            {deviceFamily === "WiFi" && addDeviceDialogue && <Dialog disableBackdropClick disableEscapeKeyDown open={addDeviceDialogue} onClose={handleCloseAddDevice}>
                <DialogTitle>{t("addDevice")}</DialogTitle>
                <DialogContent className={classes.root}>
                    <Typography variant="h6">
                        NOTE:  For Field Test product (green plastic), reference the additional activation code sticker on the product!
                    </Typography>
                    <img edge='start'
                        alt='Wi-Fi Activation Code'
                        className={classes.HubInfoImg}
                        src={WiFiActivationCodeImg} />
                    <Typography variant="body2">
                        {t("activationCodeCanBeFound")}
                    </Typography>
                    <Typography variant="body2">
                        {t("add")}{deviceFamily + " " + t("device") + " "} {targetUID}?
                    </Typography>
                    <FormControl className={classes.formControl}>
                        <TextField label="Activation Code"
                            inputRef={ractivationCode}
                            value={activationCode}
                            onChange={e => setActivationCode(e.target.value.toUpperCase())} />
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseAddDevice} color="primary">
                        {t("cancel")}
                    </Button>
                    <Button variant="contained" onClick={handleAddDevice} color="primary">
                        {t("add")}
                    </Button>
                </DialogActions>
            </Dialog>}

            <Hidden smDown>
                <FormControl className={classes.formControl}>
                    <TextField type="test" label={t("serialNumber")}
                        inputRef={rdeviceUID}
                        value={deviceUID}
                        onChange={(e) => {
                            const regex = /^([ a-zA-Z0-9]){0,30}$/i;
                            if (regex.test(e.target.value)) {
                                setDeviceUID(e.target.value.toUpperCase());
                            }
                        }
                        }
                        helperText={t("tankLevelMonitor")} />
                </FormControl>
            </Hidden>
            <Button className={classes.actionButtons} onClick={handleOpenAddDevice} variant="contained" color="primary" >
                {t("addDevice")}
            </Button>
            <Tooltip title={t("help")} placement="right">
                <IconButton className={classes.helpButton} onClick={handleHelpOpen}>
                    <HelpIcon />
                </IconButton>
            </Tooltip>
            <Popper open={helpOpen}
                anchorEl={helpAnchor}
                placement='bottom-start'
                transition>
                {({ TransitionProps, placement }) => (
                    <Grow {...TransitionProps}
                        style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}>
                        <Paper>
                            <ClickAwayListener onClickAway={handleHelpClose}>
                                <MenuList autoFocusItem={helpOpen} id='settings-list-grow'>
                                    <MenuItem onClick={handleOpenCellularInfo}>
                                        {t("cellularLevelMonitor")}
                                    </MenuItem>
                                    <MenuItem onClick={handleOpenPressureInfo}>
                                        {t("pressureLevelMonitor")}
                                    </MenuItem>
                                    <MenuItem onClick={handleOpenWiFiInfo}>
                                        {t("wifiLevelMonitor")}
                                    </MenuItem>
                                    <MenuItem onClick={handleOpenHubInfo}>
                                        {t("pulseProLevelMonitor")}
                                    </MenuItem>
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>)}
            </Popper>
            {openCellularInfo && <Dialog disableEscapeKeyDown open={openCellularInfo} onClose={handleCloseCellularInfo}>
                <DialogTitle>{t("cellularLevelMonitor")}</DialogTitle>
                <DialogContent className={classes.infoDialog}>
                    <img edge='start'
                        alt={t("cellularLevelMonitor")}
                        className={classes.HubInfoImg}
                        src={cellularInfoImg} />
                    <Typography variant="body2">
                        {t("findDeviceSerialNumber1")}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseCellularInfo} color="primary">
                        {t("close")}
                    </Button>
                </DialogActions>
            </Dialog>}
            {openPressureInfo && <Dialog disableEscapeKeyDown open={openPressureInfo} onClose={handleClosePressureInfo}>
                <DialogTitle>{t("pressureLevelMonitor")}</DialogTitle>
                <DialogContent className={classes.infoDialog}>
                    <img edge='start'
                        alt={t("pressureLevelMonitor")}
                        className={classes.HubInfoImg}
                        src={pressureInfoImg} />
                    <Typography variant="body2">
                        {t("findDeviceSerialNumber1")}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClosePressureInfo} color="primary">
                        {t("close")}
                    </Button>
                </DialogActions>
            </Dialog>}
            {openWiFiInfo && <Dialog disableEscapeKeyDown open={openWiFiInfo} onClose={handleCloseWiFiInfo}>
                <DialogTitle>{t("wifiLevelMonitor")}</DialogTitle>
                <DialogContent className={classes.root}>
                    <img edge='start'
                        alt={t("wifiLevelMonitor")}
                        className={classes.HubInfoImg}
                        src={WiFiInfoImg} />
                    <Typography variant="body2">
                        {t("findDeviceSerialNumber2")}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseWiFiInfo} color="primary">
                        {t("close")}
                    </Button>
                </DialogActions>
            </Dialog>}
            {openHubInfo && <Dialog className={classes.infoDialog} disableEscapeKeyDown open={openHubInfo} onClose={handleCloseHubInfo}>
                <DialogTitle>{t("pulseProLevelMonitor")}</DialogTitle>
                <DialogContent className={classes.root}>
                    <img edge='start'
                        alt={t("pulseProLevelMonitor")}
                        className={classes.HubInfoImg}
                        src={pulseHubInfoImg} />
                    <Typography variant="body2">
                        {t("findDeviceSerialNumber3")}
                    </Typography>
                    <Typography variant="body2">
                        {t("findDeviceSerialNumber4")}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseHubInfo} color="primary">
                        {t("close")}
                    </Button>
                </DialogActions>
            </Dialog>}
        </Fragment>
    );
};

export default ActivateDevice2;